// 画布配置常量
export const CANVAS_CONFIG = {
  SPRITE_WIDTH: 48,
  SPRITE_HEIGHT: 96,
  MAX_HISTORY_SIZE: 50,
  VIEWPORT_MARGIN: 50,
  MIN_SCALE: 0.5,
  MAX_SCALE: 5,
  SCALE_FACTOR: 1.1,
  CHECKER_SIZE_MULTIPLIER: 2,
  MULTI_TOUCH_DETECTION_TIMEOUT: 50, // 多点触控检测超时时间(ms)
} as const;

// 模式类型
export enum EditorMode {
  PAINT = "paint",
  ZOOM = "zoom",
  BRUSH = "brush",
  ERASER = "eraser",
  EYEDROPPER = "eyedropper",
}

// 默认配置
export const DEFAULT_CONFIG = {
  MODE: EditorMode.ZOOM,
} as const;
